import { render } from "./FormInput.vue?vue&type=template&id=39048a7c"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/farhad/Hemsidan/fartow-se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__